import React, { Component } from 'react';
import './App.css';
import { connect } from 'react-redux';
import { RootNavigator } from "./navigators/RootNavigator";
import { addNavigationHelpers } from "react-navigation";

import BrowserAppContainer from "./boilerplate/BrowserAppContainer";
const BrowserRootNavigator = BrowserAppContainer(RootNavigator);

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="App-header">
          <h2>SnookerMate</h2>
        </div>
        <BrowserRootNavigator navigation={addNavigationHelpers({
          dispatch: this.props.dispatch,
          state: this.props.navState,
        })}/>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    messages: state.mqtt.messages,
    navState: state.navigation
  }
})(App);



// WEBPACK FOOTER //
// ./src/App.js